import React, { SyntheticEvent, useState } from "react";
import SidePanelSection from "components/shared-ui/side-panel-section/side-panel-section";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { IRecommendProps, Recommended } from "./recommended";
import {
  IPoolSectionProps,
  PoolSection,
} from "components/common/sections/pool-section/pool-section";
import { IIdName } from "api/entities/id-name";
import { IStoragePoolConfig } from "api/entities/deployment-job";

export interface IShardClusterSection
  extends IRecommendProps,
    IPoolSectionProps {
  onChange: (storagePool: IIdName<string> | IStoragePoolConfig) => void;
}

export const ShardClusterSection = (props: IShardClusterSection) => {
  const [expanded, setExpanded] = useState<string | false>("recommended");

  const handleChange =
    (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <SidePanelSection testId="storagePool" title="Shard Repository Configuration">
      <Accordion
        expanded={expanded === "recommended"}
        onChange={handleChange("recommended")}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="recommended-content"
          id="recommended-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            Recommended
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Offers sufficient resiliency and security for most deployments
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Recommended
            bucketName={props.bucketName}
            onChange={props.onChange}
          />
        </AccordionDetails>
      </Accordion>
      {/* <Accordion
        expanded={expanded === "advanced"}
        onChange={handleChange("advanced")}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="recommended-content"
          id="recommended-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>Advanced</Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Select Existing Shard Clusters or Create a new one with custom
            repositories
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <PoolSection
            onChange={props.onChange}
            onNewStoragePoolClick={props.onNewStoragePoolClick}
            storagePool={props.storagePool}
            errors={props.errors}
            isReadonly={props.isReadonly}
            onError={props.onError}
            embedded
          />
        </AccordionDetails>
      </Accordion> */}
    </SidePanelSection>
  );
};
